import { httpRequest } from '@/utils/request';
import { CommonResponse } from '@/types';
import { request } from 'src/utils/request';

export function getHomePageInfo<T>() {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/home-page',
    method: 'get',
  });
}

export async function getDeviceMessage(data: {
  metricsType: string; // 支持1h、24h、1week
  startTime: number; // 开始时间
  endTime: number; // 结束时间
}) {
  return request<CommonResponse<{ count: number; time: string }[]>>(`/api/v1/devices-message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
}

export async function getCurrent() {
  return request<
    CommonResponse<{
      procs: number;
      load1: number; // 1分钟负载率
      load5: number; // 5分钟负载率
      load15: number; // 15分钟负载率
      loadUsagePercent: number; // 负载率
      loadInfo: string;
      cpuUsedPercent: number; // cpu使用率
      cpuUsed: number; // cpu已用
      cpuTotal: number; // cpu总数
      memoryTotal: string; // 内存总量
      memoryAvailable: string; // 内存可用
      memoryUsed: string; // 内存已用
      memoryUsedPercent: number; // 内存使用率
      diskTotal: string; // 磁盘总量
      diskUsed: string; // 磁盘已用
      diskFree: string; // 磁盘剩余
      diskUsedPercent: number; // 磁盘使用率
    }>
  >(`/api/v1/current`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
